import React from "react";
import Pagination from "./Pagination";

export default function TableFooter({
    shown,
    total,
    currentPage,
    totalCount,
    onPageChange
}) {
    return (
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 px-6 py-4 bg-indigo-50 border-t border-gray-100">
            <p className="text-sm text-gray-600">
                Showing <span className="font-semibold text-gray-700">{shown}</span> of{" "}
                <span className="font-semibold text-gray-700">{total}</span> employees
            </p>

            <Pagination
                currentPage={currentPage}
                totalCount={totalCount}
                onPageChange={onPageChange}
            />
        </div>
    );
}